import React from 'react';

type AuthCardProps = {
  children: React.ReactNode;
};

const AuthCard: React.FC<AuthCardProps> = ({ children }) => (
  <div
    className="rounded-xl shadow-2xl p-8 w-full max-w-xl flex flex-col items-center"
    style={{ backgroundColor: 'var(--color-login-card-bg, white)' }}
  >
    {children}
  </div>
);

export default AuthCard;
